import React from "react";
import "./ServiceCard.css";

const services = [
  {
    title: "Sales & Service",
    description: "We provide high-quality thermal imaging equipment for medical professionals and clinics. Our team offers complete support, including setup, maintenance, and training.",
  },
  {
    title: "Clinical Applications",
    description: "Our Infrared solutions assist healthcare providers in early detection of abnormalities, monitoring treatment progress, and enhancing diagnostic accuracy.",
  },
  {
    title: "Thermal Scanning",
    description: "We offer professional thermal scanning services for individuals and clinics. Our advanced imaging technology ensures accurate and reliable detection.",
  },
  {
    title: "Training",
    description: "We provide comprehensive training programs for healthcare professionals on the use of thermal imaging in diagnostics. Our courses cover best practices and latest advancements.",
  },
  {
    title: "Interpretation & Reporting",
    description: "Our expert team provides detailed reports and professional interpretations of thermal scans, offering insights into potential health concerns and recommendations.",
  },
  {
    title: "Rental",
    description: "We offer Infrared equipment rental for healthcare professionals, research institutions, and clinics, providing cost-effective access to advanced technology.",
  },
  {
    title: "Medical Research",
    description: "Our Infrared technology supports medical research in breast health, cancer detection, and other physiological studies. We collaborate with healthcare institutions.",
  },
  {
    title: "Breast Screening Camps",
    description: "We organize breast Infrared screening camps to promote early detection and awareness. These camps provide accessible, non-invasive breast health checks.",
  },
];

const ServiceCard = () => {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Services Offered</h2>
      <div class="why-thermal-line"></div>
      <div className="row">
        {services.map((service, index) => (
          <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
            <div className="card service-card w-100">
              <div className="card-body">
                <h5 className="card-title">{service.title}</h5>
                <p className="card-text text-black">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCard;
